import { render, staticRenderFns } from "./LegendPrognose.vue?vue&type=template&id=e91789d6&"
import script from "./LegendPrognose.vue?vue&type=script&lang=js&"
export * from "./LegendPrognose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports